<template>
  <div style="position: relative;" class="bg-white pl-4 pt-4 rounded">
    <div v-if="!hideGoBack" class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
      <div class="d-flex" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;">
          <path
            d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087"
            stroke="#FF7C48"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="d-flex align-items-center" style="margin-left: 1.25rem;">
          <div>
            <h1 class="title">{{ $t("audit-control.control.detail") }}</h1>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div v-if="!isEditMode">
            <!-- <b-button v-if="canApprove" variant="success" class="mr-2" @click="openApprovalModal('APPROVE')">
              <i class="bx bx-check font-size-16 align-middle"></i> {{ $t("common.approve") }}
            </b-button>
            <b-button v-if="canApprove" variant="danger" class="mr-2" @click="openApprovalModal('REJECT')">
              <i class="bx bx-x font-size-16 align-middle"></i> {{ $t("common.reject") }}
            </b-button> -->
            <b-button variant="primary" @click="enableEditMode" :disabled="!canEdit"> <i class="bx bx-pencil font-size-16 align-middle"></i> {{ $t("common.edit") }} </b-button>
          </div>
          <div v-else>
            <b-button variant="success" class="mr-2" @click="save"> <i class="bx bx-check font-size-16 align-middle"></i> {{ $t("common.save") }} </b-button>
            <b-button variant="danger" @click="cancelEditMode"> <i class="bx bx-x font-size-16 align-middle"></i> {{ $t("common.cancel") }} </b-button>
          </div>
        </div>
      </div>
    </div>

    <ComplianceItemSelect id="compliance-item-modal-select" multiple="true" :title="$t('compliance-item.add')" store="libraryComplianceItem" @selected="addComplianceItems" />
    <!-- <ModalSelect id="risk-modal-select" title="Risk Seç" store="organizationRisk" :multiple="true" @selected="addRisks" /> -->

    <content-loading v-if="isLoading" />
    <div v-else class="pr-4 pb-4">
      <!-- Summary Header Section -->
      <div class="bg-light p-4 rounded mb-4 border relative" style="background-color: #e2e2e2; position: relative;">
        <div class="mr-3 text-right">
          <i
            class="bx bx-block text-danger font-size-24 mr-3 hand"
            v-if="['AWAITING_APPROVAL', 'ACTIVE', 'REJECTED_EVALUATING', 'EDIT_REQUESTED_EVALUATING'].includes(control.status)"
            @click="cancelControl"
            v-b-tooltip.hover
            :title="$t('audit-finding.action.cancel')"
          ></i>

          <i
            class="bx bx-minus-circle text-secondary font-size-24 hand"
            v-if="control.status !== 'PASSIVE' && control.status !== 'CANCELED'"
            @click="makePassive"
            v-b-tooltip.hover
            :title="$t('audit-finding.action.makePassive')"
          ></i>

          <i
            class="bx bx-play-circle text-success font-size-24 hand"
            v-if="control.status === 'PASSIVE' || control.status === 'COMPLETED'"
            @click="makeActive"
            v-b-tooltip.hover
            :title="$t('audit-finding.action.makeActive')"
          ></i>
        </div>
        <!-- Period Badge - Top Right -->
        <span class="font-weight-bold">{{ $t("audit-control.control.no") }} :</span>
        <div class="d-flex justify-content-between mb-3">
          <div>
            <!-- {{ control.no }} -->
            <sweet-input :disableValidation="true" v-model="control.no" disabled></sweet-input>
          </div>

          <div class="d-flex align-items-center">
            <div style="background: white; padding: 5px 10px; border-radius: 4px; border: 1px solid #ccc;">
              <div class="d-flex align-items-center">
                <span class="font-weight-bold mr-2">Kontrol Periyodu :</span>
                <div v-if="isEditMode" class="d-flex">
                  <b-form-input type="number" v-model="localControl.period.value" size="sm" class="mr-1" style="width: 60px;"></b-form-input>
                  <b-form-select v-model="localControl.period.unit" size="sm" :options="periodOptions" style="width: 100px;"></b-form-select>
                </div>
                <div v-else>
                  <span>{{ localControl.period.value }} {{ $t("audit-control.unit." + (localControl.period.unit || "MONTH").toLowerCase()) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <!-- Col 1 -->
          <div class="col-md-4">
            <div class="mb-2">
              <span class="font-weight-bold">{{ $t("audit-control.control.category") }} :</span>
              <right-panel
                v-if="isEditMode"
                class="ml-2 d-inline-block"
                @hidden="categoryPanelClosed"
                id="sidebar-new-control-category"
                :text="$t('audit-control.control.new-category')"
                width="600px"
                :icon="'mdi mdi-plus'"
              >
                <div class="pl-5 pr-5">
                  <ControlCategoryForm />
                </div>
              </right-panel>
              <span v-if="!isEditMode">
                <span v-if="control.category">{{ control.category.name | translate }}</span>
              </span>
              <div v-else>
                <filter-select
                  ref="controlCategoryFilter"
                  v-model="localControl.category"
                  :selected="localControl.category"
                  @filter="onControlCategorySearch"
                  @changed="onControlCategorySelect"
                  :placeholder="$t('audit-control.control.category')"
                />
              </div>
            </div>
            <div class="form-group mb-0 mt-3">
              <span class="font-weight-bold">{{ $t("audit-control.control.manager") }} :</span>

              <span v-if="!isEditMode && control.manager">{{ control.manager.name }}</span>
              <organization-member-select v-else class="d-block" :selected="localControl.manager" @onSelect="(val) => (localControl.manager = val)" />
              <!-- <sweet-input :disableValidation="true" v-else v-model="localControl.manager" class="mt-1" /> -->
            </div>
          </div>
          <!-- Col 2 -->
          <div class="col-md-4">
            <div class="mb-2">
              <span class="font-weight-bold">{{ $t("audit-control.control.class") }} :</span>
              <span v-if="!isEditMode">{{ control.class ? $t("audit-control.class." + control.class.toLowerCase()) : "" }}</span>
              <b-form-select v-else v-model="localControl.class" size="sm" class="mt-1">
                <option v-if="!allowedClass || allowedClass === 'COMPLIANCE_MANAGEMENT'" value="COMPLIANCE_MANAGEMENT">{{
                  $t("audit-control.class.compliance_management")
                }}</option>
                <option v-if="!allowedClass || allowedClass === 'CONTROL_ACTIVITY'" value="CONTROL_ACTIVITY">{{ $t("audit-control.class.control_activity") }}</option>
                <option v-if="!allowedClass || allowedClass === 'AUDIT_ACTIVITY'" value="AUDIT_ACTIVITY">{{ $t("audit-control.class.audit_activity") }}</option>
              </b-form-select>
            </div>
            <div class="mb-2 mt-4">
              <span class="font-weight-bold">{{ $t("audit-control.control.criticality") }} <span class="text-danger" v-if="isEditMode">*</span> :</span>
              <span v-if="!isEditMode">{{ control.criticality ? $t("audit-control.criticality." + control.criticality.toLowerCase()) : "" }}</span>
              <b-form-select v-else v-model="localControl.criticality" size="sm" class="mt-1">
                <option value="LOW">{{ $t("audit-control.criticality.low") }}</option>
                <option value="MEDIUM">{{ $t("audit-control.criticality.medium") }}</option>
                <option value="HIGH">{{ $t("audit-control.criticality.high") }}</option>
                <option value="CRITICAL">{{ $t("audit-control.criticality.critical") }}</option>
              </b-form-select>
            </div>
          </div>
          <!-- Col 3 -->
          <div class="col-md-4">
            <div class="mb-2">
              <span class="font-weight-bold">Kontrol Durumu :</span>
              <span v-if="!isEditMode || true">
                {{ control.status ? $t("audit-control.status." + control.status.toLowerCase()) : "" }}
              </span>
              <!-- Status editing disabled as per requirements -->
              <!-- <b-form-select v-else v-model="localControl.status" size="sm" class="mt-1">
                <option value="ACTIVE">{{ $t("audit-control.status.active") }}</option>
                <option value="AWAITING_APPROVAL">{{ $t("audit-control.status.awaiting_approval") }}</option>
                <option value="EVALUATING">{{ $t("audit-control.status.evaluating") }}</option>
                <option value="COMPLETED">{{ $t("audit-control.status.completed") }}</option>
                <option value="PASSIVE">{{ $t("audit-control.status.passive") }}</option>
              </b-form-select> -->
            </div>
            <div class="mb-2 mt-4">
              <span class="font-weight-bold">{{ $t("audit-control.control.type") }} :</span>
              <right-panel
                v-if="isEditMode"
                class="ml-2 d-inline-block"
                @hidden="typePanelClosed"
                id="sidebar-new-control-type"
                :text="$t('audit-control.control.new-type')"
                width="600px"
                :icon="'mdi mdi-plus'"
              >
                <div class="pl-5 pr-5">
                  <ControlTypeForm />
                </div>
              </right-panel>
              <span v-if="!isEditMode">
                <span v-if="control.type">{{ control.type.name | translate }}</span>
              </span>
              <div v-else class="mt-1">
                <filter-select
                  ref="controlTypeFilter"
                  :selected="localControl.type"
                  @filter="onControlTypeSearch"
                  @changed="onControlTypeSelect"
                  :placeholder="$t('audit-control.control.type')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4">
            <span class="font-weight-bold">{{ $t("audit-control.control.owner") }} :</span>
            <span v-if="!isEditMode">
              <span v-if="control.owner && control.owner.organization">{{ $t("audit-control.control-level.corporate") }}</span>
              <span v-if="control.owner && control.owner.department">{{ $t("department.text") }}</span>
              <span v-if="control.owner && control.owner.process">{{ $t("process.text") }}</span>
            </span>
            <select v-else @change="ownerChanded" class="form-control mt-1" v-model="selectedOwnerType">
              <option value="ORGANIZATION">{{ $t("audit-control.control-level.corporate") }}</option>
              <option value="DEPARTMENT">{{ $t("department.text") }}</option>
              <option value="PROCESS">{{ $t("process.text") }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <span v-if="control.owner && control.owner.organization" class="font-weight-bold">{{ $t("organization.name") }}:</span>
            <span v-if="control.owner && control.owner.department" class="font-weight-bold">{{ $t("department.name") }}:</span>
            <span v-if="control.owner && control.owner.process" class="font-weight-bold">{{ $t("process.name") }}:</span>
            <div v-if="!isEditMode">
              <span v-if="control.owner && control.owner.organization"> {{ control.owner.organization.name }}</span>
              <span v-if="control.owner && control.owner.department"> {{ control.owner.department.name | translate }}</span>
              <span v-if="control.owner && control.owner.process"> {{ control.owner.process.name | translate }}</span>
            </div>
            <div v-else>
              <div v-if="selectedOwnerType == 'ORGANIZATION'">
                <filter-select
                  disabled
                  v-show="currentOrganization"
                  class="mt-1"
                  :selected="{ _id: currentOrganization._id, name: { tr: currentOrganization.name, en: currentOrganization.name } }"
                  :placeholder="$t('organization.text')"
                  :multiple="false"
                  :custom-label="customLabel"
                />
              </div>
              <div v-show="selectedOwnerType == 'DEPARTMENT'">
                <filter-select
                  class="mt-1"
                  ref="departmentFilter"
                  :selected="localControl.owner ? localControl.owner.department : null"
                  :placeholder="$t('department.text')"
                  :multiple="false"
                  @filter="onDepartmentSearch"
                  @changed="onDepartmentSelect"
                />
              </div>
              <div v-show="selectedOwnerType == 'PROCESS'">
                <filter-select
                  class="mt-1"
                  ref="processFilter"
                  @filter="onProcessSearch"
                  :selected="localControl.owner ? localControl.owner.process : null"
                  :placeholder="$t('process.text')"
                  :multiple="false"
                  @changed="onProcessSelect"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>

        <!-- Row 3: Definition -->
        <div class="row mt-3 mb-4">
          <div class="col-md-12 text-break">
            <span class="font-weight-bold">{{ $t("audit-control.control.description") }} :</span>
            <p v-if="!isEditMode" class="mb-0 mt-1 pl-2">{{ control.name | translate }}</p>
            <sweet-textarea v-else v-model="localControl.name" :rows="3" class="mt-2" />
          </div>
          <div class="col-md-12 text-break mt-2">
            <span class="font-weight-bold">{{ $t("audit-control.control.goal") }} :</span>
            <p v-if="!isEditMode" class="mb-0 mt-1 pl-2">{{ control.goal | translate }}</p>
            <sweet-textarea v-else v-model="localControl.goal" :rows="3" class="mt-2" />
          </div>
        </div>
        <div class="mb-4 pl-2">
          <label class="font-weight-bold">Risk Notu :</label>
          <p v-if="!isEditMode" class="mb-0 mt-1 pl-2">{{ control.riskNote | translate }}</p>
          <sweet-textarea v-else v-model="localControl.riskNote" :rows="3" class="mt-2" />
        </div>
        <div class="mb-4 pl-2">
          <label class="font-weight-bold">{{ $t("audit-control.related-standards") }} :</label>
          <p v-if="!isEditMode" class="mb-0 mt-1 pl-2">{{ control.relatedStandards | translate }}</p>
          <sweet-textarea v-else v-model="localControl.relatedStandards" :rows="3" class="mt-2" />
        </div>

        <!-- Accordions -->
        <!-- 1. Related Compliance Items -->
        <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-compliances'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-check-circle mr-2"></i>{{ $t("policy.related-compliances") }}</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-compliances" role="tabpanel" v-model="accordionState.compliances">
            <b-card-body>
              <div class="text-right mb-2">
                <b-button
                  v-if="control.status != 'COMPLETED'"
                  :disabled="control.status === 'AWAITING_APPROVAL' || control.status === 'REJECTED_EVALUATING'"
                  variant="outline-primary"
                  size="sm"
                  title="Sadece Onaylandı Değerlendirmede Statüsündeki Kontroller İçin Uyumluluk Eklenebilir"
                  @click="$bvModal.show('compliance-item-modal-select')"
                >
                  <i class="bx bx-plus"></i> {{ $t("common.add") }}
                </b-button>
              </div>

              <table class="table table-bordered table-striped table-light">
                <thead class="bg-soft-secondary">
                  <tr>
                    <td class="w-10">{{ $t("compliance-item.compliance") }}</td>
                    <td class="w-10">{{ $t("compliance-item-group.text") }}</td>
                    <td class="w-10">{{ $t("compliance-item.no") }}</td>
                    <td class="w-10">{{ $t("compliance-item.level") }}</td>
                    <td class="w-25">{{ $t("compliance-item.name") }}</td>
                    <td class="w-30">{{ $t("compliance-item.description") }}</td>
                    <td class="w-5"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in localControl.complianceItems" :key="item._id">
                    <td>{{ item.compliance }}</td>
                    <td>
                      <span v-if="item.group">{{ item.group.name | translate }}</span>
                    </td>
                    <td>{{ item.no }}</td>
                    <td>{{ item.level }}</td>
                    <td>{{ item.name | translate }}</td>
                    <td>{{ item.description | translate }}</td>

                    <td>
                      <i
                        v-if="!['AWAITING_APPROVAL', 'REJECTED_EVALUATING', 'COMPLETED'].includes(control.status)"
                        class="bx bx-trash hand text-danger font-size-18"
                        @click="removeComplianceItemDirect(item._id)"
                      ></i>
                    </td>
                  </tr>
                  <tr v-if="localControl.complianceItems && localControl.complianceItems.length == 0">
                    <td colspan="7" class="text-center">{{ $t("common.no-data") }}</td>
                  </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- 4. Control Tests -->
        <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-tests'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-test-tube mr-2"></i>{{ $t("audit-control.control.tests") }}</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-tests" role="tabpanel" @show="fetchTests" v-model="accordionState.tests">
            <b-card-body>
              <div class="text-right mb-2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="openTestPanel()"
                  :disabled="control.status !== 'ACTIVE'"
                  title="Sadece Onaylandı Değerlendirmede statüsündeki kontroller için test eklenebilir"
                >
                  <i class="bx bx-plus"></i> {{ $t("common.add") }}
                </b-button>
              </div>
              <table class="table table-bordered table-striped" v-if="testsPagination">
                <thead class="bg-soft-info">
                  <tr>
                    <th>{{ $t("audit-control.test.no") }}</th>
                    <th>{{ $t("audit-control.test.performed-by") }}</th>
                    <th v-if="control.class == 'AUDIT_ACTIVITY'">{{ $t("audit-control.audit.text-2") }}</th>
                    <th>{{ $t("audit-control.test.start-date") }}</th>
                    <th>{{ $t("audit-control.test.completion-date") }}</th>
                    <th>{{ $t("audit-control.test.result.text") }}</th>
                    <th>{{ $t("audit-control.test.status.text") }}</th>
                    <th style="width: 100px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="test in testsPagination.docs" :key="test._id">
                    <td>{{ test.no }}</td>
                    <td>
                      <span v-if="test.performedBy">{{ test.performedBy.name }} {{ test.performedBy.surname }}</span>
                    </td>
                    <td v-if="control.class == 'AUDIT_ACTIVITY' && test.audit">
                      <span>{{ test.audit.no }}</span> - {{ test.audit.name | translate }}
                    </td>
                    <td>{{ test.startDate | date }}</td>
                    <td>{{ test.completionDate | date }}</td>
                    <td>
                      <span v-if="test.result">{{ $t("audit-control.test.result." + test.result.toLowerCase()) }}</span>
                    </td>
                    <td>
                      <span>{{ $t("audit-control.test.status." + test.status.toLowerCase()) }}</span>
                    </td>
                    <td>
                      <div>
                        <i
                          :class="test.status === 'COMPLETED' ? 'bx bx-show text-info' : 'bx bx-edit text-primary'"
                          class="hand font-size-18 mr-2"
                          @click="openTestPanel(test)"
                        ></i>
                        <!-- <i class="bx bx-list-plus hand text-success font-size-18 mr-2" @click="openFindingPanel(test._id, null)" title="Add Finding"></i> -->
                        <i v-if="test.status !== 'COMPLETED'" class="bx bx-trash hand text-danger font-size-18" @click="deleteTest(test._id)"></i>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="testsPagination.totalDocs == 0">
                    <td colspan="7" class="text-center">{{ $t("common.no-data") }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="row" v-if="testsPagination">
                <div class="col">
                  <b-pagination
                    v-model="requests.test.options.page"
                    :total-rows="testsPagination.totalDocs"
                    :per-page="testsPagination.limit"
                    align="center"
                    @change="fetchTests"
                  ></b-pagination>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- 2. Related Risks -->
        <!-- <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-risks'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-error mr-2"></i>{{ $t("audit-control.control.risks") }}</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-risks" role="tabpanel" v-model="accordionState.risks">
            <b-card-body>
              <div class="text-right mb-2">
                <b-button variant="outline-primary" size="sm" @click="$bvModal.show('risk-modal-select')"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </b-button>
              </div>
              <table class="table table-bordered table-striped">
                <thead class="bg-soft-danger">
                  <tr>
                    <th>{{ $t("risk.name") }}</th>
                    <th>{{ $t("risk.threat-definition.text") }}</th>
                    <th>{{ $t("risk.weakness-definition.text") }}</th>
                    <th style="width: 50px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="risk in localControl.risks" :key="risk._id">
                    <td>{{ risk.name | translate }}</td>
                    <td>{{ displayDefinitions(risk.threats) }}</td>
                    <td>{{ displayDefinitions(risk.weaknesses) }}</td>
                    <td>
                      <i class="bx bx-trash hand text-danger font-size-18" @click="removeRisk(risk._id)"></i>
                    </td>
                  </tr>
                  <tr v-if="localControl.risks && localControl.risks.length == 0">
                    <td colspan="4" class="text-center">{{ $t("common.no-data") }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="mb-4 pl-2">
                <label class="font-weight-bold">Risk Notu :</label>
                <p v-if="!isEditMode" class="mb-0 mt-1 pl-2">{{ control.riskNote | translate }}</p>
                <sweet-textarea v-else v-model="localControl.riskNote" :rows="3" class="mt-2" />
              </div>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- 3. Approval -->
        <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-approval'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-user-check mr-2"></i>{{ $t("audit-control.approval.status.text") }}</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-approval" role="tabpanel" v-model="accordionState.approval">
            <b-card-body>
              <!-- Action Box -->
              <div v-if="control.status === 'AWAITING_APPROVAL' && canResolveApproval" class="mb-4">
                <div class="card border-light bg-light">
                  <div class="card-body">
                    <h5 class="card-title mb-3">{{ $t("audit-control.approval.status.text") }}</h5>
                    <div class="row">
                      <div class="col-md-12">
                        <b-form-group :label="$t('audit-control.approval.status.text')" class="font-weight-bold">
                          <b-form-radio-group
                            v-model="approvalAction"
                            :options="[
                              { text: $t('audit-control.approval.status.approved'), value: 'APPROVED' },
                              { text: $t('audit-control.approval.status.rejected'), value: 'REJECTED' },
                              { text: $t('audit-finding.action.request-edit'), value: 'REQUEST_EDIT' },
                            ]"
                            buttons
                            button-variant="outline-primary"
                            name="approval-action-radios"
                          ></b-form-radio-group>
                        </b-form-group>
                      </div>
                      <div class="col-md-12">
                        <b-form-group :label="$t('audit-control.approval.approval.response-note')" class="font-weight-bold">
                          <b-form-textarea v-model="approvalNote" :placeholder="$t('common.enterNote')" rows="3"></b-form-textarea>
                        </b-form-group>
                      </div>
                      <div class="col-md-12 text-right">
                        <b-button @click="resolveApproval()" :disabled="isSendingApproval || !approvalAction" :loading="isSendingApproval" variant="primary" class="px-4">
                          {{ $t("common.send") }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Approval History Table -->
              <div v-if="localControl.approvals && localControl.approvals.length > 0">
                <h6 class="mb-3 font-weight-bold">{{ $t("audit-control.approval.approval-history") }}</h6>
                <div class="table-responsive">
                  <table class="table table-bordered table-striped table-hover mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th>{{ $t("audit-control.approval.approval.status") }}</th>
                        <th>{{ $t("audit-control.approval.approval.requested-by") }}</th>
                        <th>{{ $t("audit-control.approval.approval.requested-at") }}</th>
                        <th>{{ $t("audit-control.approval.approval.request-note-control") }}</th>
                        <th>{{ $t("audit-control.approval.approval.responded-by") }}</th>
                        <th>{{ $t("audit-control.approval.approval.responded-at") }}</th>
                        <th>{{ $t("audit-control.approval.approval.response-note-control") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(approval, index) in localControl.approvals" :key="index">
                        <td>
                          <b-badge :variant="getApprovalStatusVariant(approval.status)">
                            {{ approval.status ? $t("audit-control.approval.status." + approval.status.toLowerCase()) : "" }}
                          </b-badge>
                        </td>
                        <td>{{ approval.requestedBy ? approval.requestedBy.name : "-" }}</td>
                        <td>{{ approval.requestedAt | date }}</td>
                        <td>{{ approval.requestNote | translate }}</td>
                        <td>
                          <span v-if="approval.respondedBy">{{ approval.respondedBy.name }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>
                          <span v-if="approval.respondedAt">{{ approval.respondedAt | date }}</span>
                          <span v-else>-</span>
                        </td>
                        <td>{{ approval.responseNote | translate }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="text-center text-muted p-3">
                {{ $t("common.no-data") }}
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- 4. Related Findings -->
        <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-findings'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-search-alt mr-2"></i>{{ $t("audit-control.related-findings") }}</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-findings" role="tabpanel" @show="fetchFindings" v-model="accordionState.findings">
            <b-card-body>
              <div class="text-right mb-2">
                <!-- <b-button variant="outline-primary" size="sm" @click="openFindingPanel()"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </b-button> -->
              </div>
              <table class="table table-bordered table-striped" v-if="findingsPagination">
                <thead>
                  <tr>
                    <th>Bulgu No</th>
                    <th>Bulgu Tanımı</th>
                    <th>Açıklama</th>
                    <th>Test No</th>
                    <th style="width: 80px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="finding in findingsPagination.docs" :key="finding._id">
                    <td>{{ finding.no }}</td>
                    <td>{{ finding.name | translate }}</td>
                    <td>{{ finding.description | translate }}</td>
                    <td>
                      <span v-if="finding.test" class="badge badge-info">{{ finding.test.no }}</span>
                    </td>
                    <td>
                      <div>
                        <i class="bx bx-edit hand text-primary font-size-18 mr-2" @click="openFindingPanel(null, finding)"></i>
                        <i class="bx bx-trash hand text-danger font-size-18" @click="deleteFinding(finding._id)"></i>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="findingsPagination.totalDocs == 0">
                    <td colspan="4" class="text-center">{{ $t("common.no-data") }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="row" v-if="findingsPagination">
                <div class="col">
                  <b-pagination
                    v-model="requests.finding.options.page"
                    :total-rows="findingsPagination.totalDocs"
                    :per-page="findingsPagination.limit"
                    align="center"
                    @change="fetchFindings"
                  ></b-pagination>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- 5.5. Files -->
        <EntityFileSection
          v-if="control._id"
          entityType="control"
          :entityId="control._id"
          :files="control.files || []"
          :canUpload="canEdit"
          uploadBaseUrl="audit-control/control"
          @uploaded="fetchDetails()"
        />

        <!-- 6. History -->
        <b-card no-body class="custom-card shadow-none custom-accordion mb-3">
          <b-card-header header-tag="header" role="tab" class="bg-white shadow-sm border-bottom-0">
            <a v-b-toggle="'accordion-history'" class="text-primary d-block font-weight-bold" href="javascript: void(0);">
              <h5 class="m-0"><i class="bx bx-history mr-2"></i>Tarihçe</h5>
            </a>
          </b-card-header>
          <b-collapse id="accordion-history" role="tabpanel" @show="fetchHistory" v-model="accordionState.history">
            <b-card-body>
              <div class="pl-3">
                <OrganizationControlHistory ref="historyComponent" v-if="control._id && historyVisible" :controlId="control._id" />
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <right-panel id="test-panel" ref="test-panel" width="1300px" :title="$t('audit-control.test.detail')" @hidden="rightPanelClosed">
        <OrganizationControlTestForm
          ref="controlTestForm"
          class="p-3"
          v-if="showTestPanel"
          :controlId="control._id"
          :test="selectedTest"
          @save="saveTest"
          @cancel="closeTestPanel"
          @open-finding="openFindingPanel"
          @delete-finding="deleteFinding"
        />
      </right-panel>

      <right-panel id="finding-panel" ref="finding-panel" width="1100px" :title="$t('audit-control.finding.detail')" @hidden="rightPanelClosed">
        <OrganizationFindingForm
          class="p-3"
          v-if="showFindingPanel"
          :controlId="control._id"
          :testId="selectedTestIdForFinding"
          :finding="selectedFinding"
          :initialControl="control"
          @save="saveFinding"
          @cancel="closeFindingPanel"
        />
      </right-panel>

      <b-modal id="approval-request-modal" :title="$t('audit-control.approval.send')" @ok="handleApprovalRequestOk">
        <b-form-group :label="$t('common.approver')">
          <organization-member-select :selected="approvalRequest.assignee" @onSelect="(val) => (approvalRequest.assignee = val)" :placeholder="$t('common.approver')" />
        </b-form-group>
        <b-form-group :label="$t('audit-control.approval.approval.request-note')">
          <b-form-textarea v-model="approvalRequest.note" :placeholder="$t('common.enterNote')" rows="3"></b-form-textarea>
        </b-form-group>
      </b-modal>

      <!-- Action Modal -->
      <b-modal v-model="actionModal.show" :title="actionModal.title" @ok="confirmAction" :ok-title="$t('common.yes')" :cancel-title="$t('common.cancel')" centered>
        <b-form-group :label="$t('common.note')" label-for="action-note">
          <b-form-textarea id="action-note" v-model="actionModal.note" :placeholder="$t('common.enterNote')" rows="3"></b-form-textarea>
        </b-form-group>
      </b-modal>
    </div>
  </div>
</template>

<script>
import SweetInput from "@c/form/sweet-input";
import SweetTextarea from "@c/form/sweet-textarea";
import ModalSelect from "@c/modal-select";
import ComplianceItemSelect from "./compliance-item-select.vue";
import OrganizationControlHistory from "./organization-control-history.vue";
import OrganizationControlTestForm from "./organization-control-test-form.vue";
import OrganizationMemberSelect from "@cc/organization-member-select";
import ControlTypeForm from "../library/workspace-library-control-type-form";
import ControlCategoryForm from "../library/workspace-library-control-category-form";
import OrganizationFindingForm from "@modules/finding/organization-finding-form.vue";
import EntityFileSection from "@c/entity-file-section.vue";

export default {
  components: {
    ModalSelect,
    ComplianceItemSelect,
    SweetInput,
    SweetTextarea,
    OrganizationControlHistory,
    OrganizationControlTestForm,
    OrganizationFindingForm,
    OrganizationMemberSelect,
    ControlTypeForm,
    ControlCategoryForm,
    EntityFileSection,
  },
  props: {
    hideGoBack: {
      type: Boolean,
      default: false,
    },
    auditId: {
      type: String,
      default: null,
    },
    backUrl: {
      type: String,
      default: null,
    },
    backUrl: {
      type: String,
      default: null,
    },
    allowedClass: {
      type: String,
      default: undefined,
    },
    lockedClass: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isThereUnsavedChange: false,
      reloadMessage: this.$t("common.reload-message"),
      isEditMode: false,
      selectedOwnerType: "ORGANIZATION",
      localControl: {
        period: { value: 0, unit: "MONTH" },
        complianceItems: [],
        risks: [],
        goal: null,
        category: null,
        class: null,
        type: null,
        criticality: null,
        status: null,
        manager: null,
        name: null,
        riskNote: null,
        relatedStandards: null,
        approval: null,
        approvals: [],
      },
      approvalAction: null,
      approvalStatus: null,
      approvalNote: null,
      approvalAssignee: null,
      approvalRequest: { assignee: null, note: "" }, // Added for modal
      isSendingApproval: false,
      showTestPanel: false,
      selectedTest: null,
      showFindingPanel: false,
      selectedFinding: null,
      selectedTestIdForFinding: null,
      requests: {
        test: {
          options: { page: 1, limit: 5 },
          query: {},
        },
        finding: {
          options: { page: 1, limit: 5 },
          query: {},
        },
      },
      accordionState: {
        compliances: false,
        risks: false,
        findings: false,
        tests: false,
        approval: false,
        history: false,
      },
      historyVisible: false,
      actionModal: {
        show: false,
        title: "",
        type: "",
        note: "",
      },
    };
  },
  computed: {
    canEdit() {
      return !["AWAITING_APPROVAL", "REJECTED_EVALUATING", "CANCELED", "PASSIVE", "COMPLETED"].includes(this.localControl.status);
    },
    canResolveApproval() {
      // Check if control is in awaiting approval state
      if (this.control.status !== "AWAITING_APPROVAL") return false;

      if (!this.localControl.approval || !this.currentAccount) return false;

      const assigneeId = this.localControl.approval.assignee?._id || null;

      if (!assigneeId) return false;

      return (
        assigneeId === this.currentAccount._id || (this.currentOrganization && this.currentOrganization.owner && this.currentOrganization.owner._id === this.currentAccount._id)
      );
    },
    isLoading() {
      return this.$store.getters["organizationControl/isLoading"];
    },
    control() {
      return this.$store.getters["organizationControl/editedEntity"] || {};
    },
    periodOptions() {
      return [
        { value: "WEEK", text: this.$t("common.week") },
        { value: "MONTH", text: this.$t("common.month") },
      ];
    },

    statusVariant() {
      switch (this.control.status) {
        case "ACTIVE":
          return "success";
        case "PASSIVE":
          return "secondary";
        case "AWAITING_APPROVAL":
          return "warning";
        case "EDIT_REQUESTED_EVALUATING":
          return "warning";
        case "REJECTED_EVALUATING":
          return "danger";
        default:
          return "primary";
      }
    },
    canApprove() {
      // Permission check logic
      // Assuming naive check for now, can be improved with store getter
      return this.control.approval && this.control.approval.status === "PENDING";
      // && (this.currentAccountHasPermissions("ORGANIZATION_INFORMATION_TECHNOLOGY_AUDITOR") || this.currentAccountHasPermissions("ORGANIZATION_ADMIN"));
    },
    testsPagination() {
      return this.$store.getters["organizationControlTest/pagination"];
    },
    findingsPagination() {
      return this.$store.getters["organizationFinding/pagination"];
    },
  },
  watch: {
    control: {
      handler(val) {
        if (val) {
          this.isThereUnsavedChange = true;
          this.syncLocalControl(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (!this.isThereUnsavedChange || !this.isEditMode) {
      next();
      return;
    }
    const answer = await this.confirm(this.reloadMessage);
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  methods: {
    beforeUnload(e) {
      if (!this.isThereUnsavedChange || !this.isEditMode) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
    categoryPanelClosed() {
      this.$refs["controlCategoryFilter"]?.reset();
    },
    typePanelClosed() {
      this.$refs["controlTypeFilter"]?.reset();
    },
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },

    async onControlTypeSearch(value, callback) {
      const response = await this.$store.dispatch(`libraryControlType/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          // "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onControlTypeSelect(value) {
      this.localControl.type = value;
    },
    async onControlCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`libraryControlCategory/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          // "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onControlCategorySelect(value) {
      this.localControl.category = value;
    },
    ownerChanded(e) {
      if (e.target.value == "ORGANIZATION") {
        this.onOrganizationSelect();
      }
      // Reset logic if needed
    },
    onOrganizationSelect() {
      const owner = { organization: this.currentOrganization };
      this.localControl = { ...this.localControl, owner };
    },
    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(department) {
      const owner = { department };
      this.localControl = { ...this.localControl, owner };
    },
    async onProcessSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationProcess/paginate`, {
        options: { limit: 200, sort: { name: "asc" } },
        query: {
          name: { value },
        },
      });
      callback(response.data?.docs ?? []);
    },
    onProcessSelect(process) {
      const owner = { process };
      this.localControl = { ...this.localControl, owner };
    },
    rightPanelClosed() {
      this.fetchDetails();
      this.fetchTests();
      this.fetchFindings();
    },
    syncLocalControl(val) {
      this.localControl = this.prepareFormForEdit(val, [, "riskNote", "relatedStandards", "goal"]);
      if (!this.localControl.period) {
        this.localControl.period = { value: 0, unit: "MONTH" };
      }

      if (val.owner) {
        if (val.owner.department) this.selectedOwnerType = "DEPARTMENT";
        else if (val.owner.process) this.selectedOwnerType = "PROCESS";
        else this.selectedOwnerType = "ORGANIZATION";
      }

      this.localControl.approvals = val.approvals || [];

      // Derive active approval from history if status is AWAITING_APPROVAL
      if (val.status === "AWAITING_APPROVAL" && this.localControl.approvals.length > 0) {
        // Approvals are LIFO (First element is latest)
        const lastApproval = this.localControl.approvals[0];
        if (lastApproval.status === "PENDING") {
          this.localControl.approval = JSON.parse(JSON.stringify(lastApproval));
        } else {
          // Fallback if status mismatch, though shouldn't happen based on business logic
          this.localControl.approval = this.getEmptyApproval();
        }
      } else {
        this.localControl.approval = this.getEmptyApproval();
      }

      if (!this.localControl.complianceItems) this.localControl.complianceItems = [];
      if (!this.localControl.risks) this.localControl.risks = [];
      this.localControl.approvals = val.approvals || [];

      // if (!this.control._id && this.allowedClass) {
      //   this.localControl.class = this.allowedClass;
      // }
    },
    enableEditMode() {
      this.syncLocalControl(this.control);
      this.isEditMode = true;
    },
    cancelEditMode() {
      this.syncLocalControl(this.control);
      this.isEditMode = false;
    },
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    updateApprovalField(field, value) {
      if (!this.localControl.approval) {
        this.localControl.approval = {
          reporter: null,
          assignee: null,
          at: null,
          status: null,
          note: null,
          reporterNote: null,
        };
      }
      this.localControl.approval[field] = value;
    },
    // Updated save method to open modal
    save() {
      this.approvalRequest = { assignee: null, note: "" };
      this.$bvModal.show("approval-request-modal");
    },
    async handleApprovalRequestOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.approvalRequest.assignee) {
        this.$toast.error(this.$t("audit-control.approval.validation.assignee-required"));
        return;
      }

      await this.confirmSave();
      this.$bvModal.hide("approval-request-modal");
    },
    async confirmSave() {
      try {
        const id = this.$route.params.id || this.control._id;
        const payload = JSON.parse(JSON.stringify(this.localControl));

        // Inject approval request info
        payload.approval = {
          assignee: this.approvalRequest.assignee,
          reporterNote: { tr: this.approvalRequest.note, en: this.approvalRequest.note },
        };

        await this.$store.dispatch("organizationControl/update", payload);
        this.$toast.success(this.$t("common.success"));
        this.isEditMode = false;

        // Refetch to ensure fresh state
        if (id) {
          await this.$store.dispatch("organizationControl/findById", id);
          const entity = this.$store.getters["organizationControl/selectedEntity"];
          const clone = JSON.parse(JSON.stringify(entity));
          this.$store.commit("organizationControl/editedEntity", clone);
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    goBack() {
      if (this.$route.query.from && this.$route.query.from == "audit-view") {
        return this.$router.push("/audit-control/audit");
      }
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        if (this.allowedClass === "COMPLIANCE_MANAGEMENT" || this.$route.path.includes("compliance")) {
          this.$router.push("/audit-control/compliance");
        } else if (this.allowedClass === "AUDIT_ACTIVITY" || this.$route.path.includes("audit-control/audit")) {
          this.$router.push("/audit-control/audit");
        } else {
          this.$router.push("/audit-control/control");
        }
      }
    },
    async requestApproval() {
      try {
        this.isSendingApproval = true;

        // Prepare payload for update
        const payload = {
          _id: this.control._id,
          approval: {
            // assignee: this.approvalAssignee, // Removed as per finding parity, backend defaults to creator/owner
            reporterNote: { tr: this.approvalNote, en: this.approvalNote },
          },
        };

        await this.$store.dispatch("organizationControl/update", payload);

        this.$toast.success(this.$t("common.success"));
        this.fetchDetails();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.isSendingApproval = false;
      }
    },
    getApprovalStatusVariant(status) {
      if (!status) return "secondary";
      switch (status) {
        case "APPROVED":
          return "success";
        case "REJECTED":
          return "danger";
        case "PENDING":
          return "warning";
        case "REQUEST_EDIT":
          return "info";
        default:
          return "secondary";
      }
    },
    async resolveApproval() {
      try {
        if (!this.approvalAction) return;

        this.isSendingApproval = true;

        if (this.approvalAction === "REQUEST_EDIT") {
          const payload = JSON.parse(JSON.stringify(this.localControl));
          payload.approval = {
            status: "REQUEST_EDIT",
            note: { [this.currentLanguage]: this.approvalNote },
          };
          await this.$store.dispatch("organizationControl/update", payload);
        } else {
          let action = "";
          if (this.approvalAction === "APPROVED") action = "organizationControl/approve";
          else if (this.approvalAction === "REJECTED") action = "organizationControl/reject";

          if (!action) return;

          await this.$store.dispatch(action, {
            controlId: this.control._id,
            description: { [this.currentLanguage]: this.approvalNote },
          });
        }

        this.$toast.success(this.$t("common.success"));
        this.fetchDetails();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.isSendingApproval = false;
        this.approvalAction = null;
        this.approvalNote = null;
      }
    },
    cancelControl() {
      this.actionModal = {
        show: true,
        title: this.$t("audit-control.action.cancel-confirm"),
        type: "CANCEL",
        note: "",
      };
    },
    makePassive() {
      this.actionModal = {
        show: true,
        title: this.$t("audit-control.action.passive-confirm"),
        type: "PASSIVE",
        note: "",
      };
    },
    makeActive() {
      this.actionModal = {
        show: true,
        title: this.$t("audit-control.action.active-confirm"),
        type: "ACTIVE",
        note: "",
      };
    },
    async confirmAction() {
      try {
        if (this.actionModal.type === "CANCEL") {
          await this.$store.dispatch("organizationControl/cancel", { controlId: this.control._id, note: this.actionModal.note });
        } else if (this.actionModal.type === "PASSIVE") {
          await this.$store.dispatch("organizationControl/passive", { controlId: this.control._id, note: this.actionModal.note });
        } else if (this.actionModal.type === "ACTIVE") {
          await this.$store.dispatch("organizationControl/active", { controlId: this.control._id, note: this.actionModal.note });
        }
        this.$toast.success(this.$t("common.successful"));
        this.actionModal.show = false;
        this.isEditMode = false;
        this.fetchDetails();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    addComplianceItems(items) {
      const currentItems = this.localControl.complianceItems || [];
      const newItems = items.filter((item) => !currentItems.some((existing) => existing._id === item._id));
      this.localControl.complianceItems = [...currentItems, ...newItems];

      // Save directly
      this.saveComplianceItems();
    },
    async saveComplianceItems() {
      try {
        await this.$store.dispatch("organizationControl/update", this.localControl);
        this.$toast.success(this.$t("common.success"));
        this.fetchDetails();
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    removeComplianceItem(id) {
      // ONLY update local state
      this.localControl.complianceItems = this.localControl.complianceItems.filter((item) => item._id !== id);
    },
    async removeComplianceItemDirect(id) {
      try {
        const ok = await this.confirm(this.$t("common.confirm-delete"));
        if (!ok) return;

        this.localControl.complianceItems = this.localControl.complianceItems.filter((item) => item._id !== id);

        // Ensure localControl contains required basic info before updating
        await this.$store.dispatch("organizationControl/update", this.localControl);
        this.$toast.success(this.$t("common.success"));

        this.fetchDetails();
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    addRisks(items) {
      const currentItems = this.localControl.risks || [];
      const newItems = items.filter((item) => !currentItems.some((existing) => existing._id === item._id));

      // ONLY update local state
      this.localControl.risks = [...currentItems, ...newItems];
    },
    removeRisk(id) {
      // ONLY update local state
      this.localControl.risks = this.localControl.risks.filter((item) => item._id !== id);
    },
    async fetchTests() {
      if (this.control._id) {
        this.requests.test.query.control = { value: this.control._id, isObject: true };
        // if (this.auditId) {
        //   this.requests.test.query.audit = { value: this.auditId, isObject: true };
        // }
        await this.$store.dispatch("organizationControlTest/paginate", this.requests.test);
      }
    },
    async fetchFindings() {
      if (this.control._id) {
        this.requests.finding.query.control = { value: this.control._id, isObject: true };
        await this.$store.dispatch("organizationFinding/paginate", this.requests.finding);
      }
    },
    async openTestPanel(test = null) {
      if (test) {
        try {
          await this.$store.dispatch("organizationControlTest/findById", test._id);
          this.selectedTest = this.$store.getters["organizationControlTest/selectedEntity"];
        } catch (error) {
          this.$handleHttpErrorByStatusCode(error);
          return;
        }
      } else {
        try {
          const query = {
            control: { value: this.control._id, isObject: true },
            status: { value: "ACTIVE", isObject: true },
          };

          if (this.control.class === "AUDIT_ACTIVITY" && this.auditId) {
            query.audit = { value: this.auditId, isObject: true };
            delete query.status; // Prevent multiple tests per audit entirely
          }

          // Check for active test across all data or scoped by audit using paginateForSearch
          const response = await this.$store.dispatch("organizationControlTest/paginateForSearch", {
            options: { limit: 1 },
            query: query,
          });

          if (response.data && response.data.totalDocs > 0) {
            if (this.control.class == "AUDIT_ACTIVITY") {
              this.$toast.warning(this.$t("audit-control.test.exception.audit-control-test-already-exists"));
            } else {
              this.$toast.warning(this.$t("audit-control.test.exception.control-already-tested"));
            }
            return;
          }
        } catch (error) {}

        this.selectedTest = {
          control: this.control._id,
        };
        if (this.auditId) {
          this.selectedTest.audit = this.auditId;
        }
      }
      this.showTestPanel = true;
      this.$root.$emit("bv::toggle::collapse", "test-panel");
    },
    closeTestPanel() {
      this.showTestPanel = false;
      this.$root.$emit("bv::toggle::collapse", "test-panel");
    },

    async saveTest(form) {
      try {
        const { data } = await this.$store.dispatch("organizationControlTest/save", form);
        this.selectedTest = data;
        await this.fetchTests();
        this.$toast.success(this.$t("common.success"));
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    async deleteTest(id) {
      // confirm
      try {
        await this.$store.dispatch("organizationControlTest/delete", id);
        await this.fetchTests();
        this.$toast.success(this.$t("common.success"));
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    openFindingPanel(testId = null, finding = null) {
      if (finding) {
        return this.$router.push(`/finding/detail/${finding._id}`);
      }
      this.selectedFinding = finding;
      this.selectedTestIdForFinding = testId;
      this.showFindingPanel = true;
      this.$root.$emit("bv::toggle::collapse", "finding-panel");
    },
    closeFindingPanel() {
      this.showFindingPanel = false;
      this.$root.$emit("bv::toggle::collapse", "finding-panel");
    },
    async saveFinding(form) {
      try {
        // await this.$store.dispatch("organizationFinding/save", form);
        this.closeFindingPanel();
        await this.fetchFindings();

        if (this.showTestPanel && this.$refs.controlTestForm) {
          this.$refs.controlTestForm.fetchFindings();
        }

        this.$toast.success(this.$t("common.success"));
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    async deleteFinding(id) {
      try {
        await this.$store.dispatch("organizationFinding/delete", id);
        await this.fetchFindings();

        if (this.showTestPanel && this.$refs.controlTestForm) {
          this.$refs.controlTestForm.fetchFindings();
        }

        this.$toast.success(this.$t("common.success"));
      } catch (e) {
        this.$handleHttpErrorByStatusCode(e);
      }
    },
    fetchHistory() {
      if (!this.historyVisible) {
        this.historyVisible = true;
      } else {
        this.$nextTick(() => {
          if (this.$refs.historyComponent) {
            this.$refs.historyComponent.fetchHistory();
          }
        });
      }
    },
    getEmptyApproval() {
      return {
        requestedBy: null,
        assignee: null,
        requestedAt: null,
        status: null,
        requestNote: null,
        responseNote: null,
        respondedBy: null,
        respondedAt: null,
      };
    },
    async fetchDetails() {
      const id = this.$route.params.controlId || this.$route.params.id;
      if (id) {
        await this.$store.dispatch("organizationControl/findById", id);
        const entity = this.$store.getters["organizationControl/selectedEntity"];

        const clone = JSON.parse(JSON.stringify(entity));
        this.$store.commit("organizationControl/editedEntity", clone);
      }
    },
  },
  async mounted() {
    await this.fetchDetails();
    this.beforeUnload = this.beforeUnload.bind(this);
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  overflow: hidden;
}

.custom-accordion .card-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 0;
}
.custom-accordion .card-header a {
  text-decoration: none;
}
</style>
